import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OrganizationWorkspace from './OrganizationWorkspace';
import { useUser } from './WebSocketContext';

/** Keep the current route mounted while organization settings are open. */
export default function OrganizationWorkspaceNavigation({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { isValidator } = useUser();
  const fallback = isValidator ? '/validate' : '/project-dashboard';
  const open = location.pathname === '/organization';
  const savedBackground = location.state?.organizationBackground;
  const hasBackground = typeof savedBackground?.pathname === 'string'
    && savedBackground.pathname.startsWith('/') && savedBackground.pathname !== '/organization';
  const background = open ? (hasBackground ? savedBackground : fallback) : location;

  return <>
    {children(background)}
    {open && <OrganizationWorkspace onClose={() => hasBackground
      ? navigate(-1) : navigate(fallback, { replace: true })} />}
  </>;
}
